var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHorizontalBars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "horizontal-bars",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "horizontal-bars-top-point",
    d: "M8.25002 14.65C8.81622 14.65 9.32685 14.3088 9.54317 13.7857C9.76004 13.2626 9.64066 12.6606 9.24003 12.26C8.8394 11.8593 8.23749 11.74 7.71439 11.9568C7.19121 12.1731 6.85 12.6838 6.85 13.25C6.85 13.6212 6.99749 13.9775 7.26001 14.24C7.52253 14.5025 7.87878 14.65 8.25002 14.65Z",
    fill: "#1422BD",
    stroke: "#1422BD",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "horizontal-bars-bottom-point",
    d: "M62.25 55.85C61.4769 55.85 60.85 56.4769 60.85 57.25C60.85 57.8162 61.1912 58.3269 61.7143 58.5432C62.2374 58.76 62.8394 58.6407 63.24 58.24C63.6407 57.8394 63.76 57.2375 63.5432 56.7145C63.3269 56.1912 62.8163 55.85 62.25 55.85Z",
    fill: "#1422BD",
    stroke: "#1422BD",
    strokeWidth: 0.3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "horizontal-bars-top-outer-bar",
    width: "49px",
    height: "8px",
    x: 7,
    y: 21,
    ry: 3,
    fill: "#1422BD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "horizontal-bars-top-inner-bar",
    width: "45px",
    height: "3px",
    x: 8,
    y: 23.5,
    ry: 1,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "horizontal-bars-middle-outer-bar",
    width: "40px",
    height: "8px",
    x: 7,
    y: 33,
    ry: 3,
    fill: "#1422BD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "horizontal-bars-middle-inner-bar",
    width: "36px",
    height: "3px",
    x: 8,
    y: 35.5,
    ry: 1,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "horizontal-bars-bottom-outer-bar",
    width: "28px",
    height: "8px",
    x: 7,
    y: 45,
    ry: 3,
    fill: "#1422BD"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "horizontal-bars-bottom-inner-bar",
    width: "24.1px",
    height: "3px",
    x: 8,
    y: 47.6,
    ry: 1,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "horizontal-bars-axis",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 16C7.55964 16 7 16.5596 7 17.25V56.75C7 56.8356 7.00861 56.9192 7.02501 57C7.00861 57.0808 7 57.1644 7 57.25C7 57.9404 7.55964 58.5 8.25 58.5H57.75C58.4404 58.5 59 57.9404 59 57.25C59 56.5596 58.4404 56 57.75 56H9.5V17.25C9.5 16.5596 8.94036 16 8.25 16Z",
    fill: "#1422BD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalBars);
export default __webpack_public_path__ + "static/media/horizontal-bars.7a5725ba6ddc06e53c89e788e3e55b16.svg";
export { ForwardRef as ReactComponent };